import Vue from 'vue'
import VueRouter from 'vue-router'
import { Cookies, LocalStorage, Notify } from 'quasar'

import routes from './routes'

Vue.use(VueRouter)

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

const token = Cookies.has('jwt')

export default function ({ store }) {
  const router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,

    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  })

  router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
      // CHECK TOKEN
      if (!token) {
        store.dispatch('auth/LOGOUT', {})
      } else {
        let accessPage = false

        const moduleRole = LocalStorage.getItem('module')
          ? LocalStorage.getItem('module')
          : false

        if (moduleRole) {
          moduleRole.find((modul) => {
            const checkAccess = (item) => {
              return (
                item.name === to.meta.name &&
                (item.read === to.meta.read &&
                (item.write === true || item.write === to.meta.write))
              )
            }

            if (modul.children && modul.children.length > 0) {
              accessPage = modul.children.some(checkAccess)
              return accessPage
            } else {
              accessPage = moduleRole.some(checkAccess)
              return accessPage
            }
          })
        }

        if (!moduleRole) {
          Cookies.remove('jwt')
          store.dispatch('auth/LOGOUT', {})
          return
        }

        // CHECK PAGE ACCESS
        if (accessPage) {
          store
            .dispatch('auth/TOKEN_CHECK', {})
            .then((response) => {
              next()
            })
            .catch(() => {
              store.dispatch('auth/LOGOUT', {})
            })
        } else {
          router.push('/')

          Notify.create({
            color: 'warning',
            message: 'Maaf, Anda tidak memiliki izin untuk mengakses menu ini.',
            icon: 'report_problem'
          })
        }
      }
    } else {
      next()
    }
  })

  return router
}
